module.exports = __webpack_public_path__ + "img/141.986be8de.jpg";